<template>
    <div>
        <transition name="slide">
            <div v-if="isDrawerOpen" class="drawer">
                <div class="inner-drawer">
                    <div class="drawer-content">
                        <vue-markdown :source="src" class="markdown-container" />
                    </div>
                    <div class="drawer-action">
                        <button class="button" @click="toggleDrawer">Close</button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import VueMarkdown from 'vue-markdown-render'

export default {
    name: 'HelpDocDrawer',
    components: {
        VueMarkdown
    },
    data() {
        return {
            isDrawerOpen: false,
            src: '',
            path: null
        };
    },
    watch: {
        path: function (newPath, oldPath) {
            if (newPath !== oldPath) {
                this.fetchDoc(newPath);
            }
        }
    },
    mounted() {
        this.$root.$on('toggle-help', this.toggleDrawer);
    },
    beforeDestroy() {
        this.$root.$off('toggle-help', this.toggleDrawer);
    },
    methods: {
        fetchDoc(path) {
            let apiPayload = {}
            apiPayload.apiEndpoint = 'help'
            apiPayload.postData = {}
            apiPayload.postData.action = 'fetch_doc'
            apiPayload.postData.doc_path = path

            this.$store.dispatch('apiCall', apiPayload).then(response => {
                if (response.data.result !== 'success') {
                    this.alertTitle = 'Error'
                    this.alertMessage = response.data.message
                    this.shouldCloseModalAndNotExit = true // when the alert is closed, don't exit the page
                    this.showAlert = true
                } else {
                    this.src = response.data.payload?.doc;
                }
            })

        },
        /**
         * Toggles the drawer open and closed
         * @param path {string} - The path to the markdown file to display
         */
        toggleDrawer(path) {
            if (path && typeof path === 'string') {
                this.path = path;
            }
            this.isDrawerOpen = !this.isDrawerOpen;
        },
    }
};
</script>

<style scoped>
.drawer {
    position: fixed;
    right: 0;
    top: 46px;
    min-width: 400px;
    width: 50vw;
    max-width: 800px;
    height: calc(100% - 46px);
    padding: 40px 20px 20px;
    background-color: white;
    box-shadow: -10px 0 25px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    transition: transform 0.3s ease;
}

.inner-drawer {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
}

.slide-enter-active,
.slide-leave-active {
    transition: transform 0.3s ease;
}

.slide-enter,
.slide-leave-to {
    transform: translateX(100%);
}

.drawer-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 90%;
}

.drawer-action {
    margin-top: 20px;
    text-align: right;
    display: flex;
    justify-content: space-between;
}
.button {
    background-color: #007AFF;
    color: white;
    border: 1px solid #007AFF;
    border-radius: 4px;
}
.markdown-container {
    height: 100%;
    overflow-y: auto;
    padding: 20px;
}
.markdown-container code {
    overflow-x: auto;
}
</style>